import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const CompanyProfileRoute = lazy(() => import("@/pages/company-profile.page"));

export const Route = createFileRoute("/company-profile")({
  component: CompanyProfileRoute,
});
